// one stroke icon set, 24 grid, square ends so it reads like silkscreen on a keycap

const PATHS: Record<string, string> = {
  today: "M4 11 12 4l8 7M6 9.5V20h12V9.5M10 20v-6h4v6",
  tasks: "M4 6h2M4 12h2M4 18h2M9 6h11M9 12h11M9 18h7",
  feed: "M4 5h16M4 10h11M4 15h16M4 20h11",
  trophy: "M7 4h10v5a5 5 0 0 1-10 0zM7 6H4v2a3 3 0 0 0 3 3M17 6h3v2a3 3 0 0 1-3 3M12 14v4M8 21h8M10 18h4",
  mic: "M9 3h6v10a3 3 0 0 1-6 0zM5 11a7 7 0 0 0 14 0M12 18v3M9 21h6",
  notes: "M6 3h9l4 4v14H6zM15 3v4h4M9 12h7M9 16h7",
  refs: "M3 5h18v14H3zM3 15l5-5 4 4 3-3 6 6M15.5 9.5h.01",
  ask: "M4 5h16v11H9l-5 4zM8 10h.01M12 10h.01M16 10h.01",
  timer: "M9 2h6M12 14V9M12 22a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM18.5 5.5 20 4",
  palette: "M12 3a9 9 0 1 0 0 18c1.5 0 2-1 2-2s-1-1.5-1-2.5S14 15 15 15h2a4 4 0 0 0 4-4c0-4.5-4-8-9-8zM7.5 11h.01M10 7h.01M15 7h.01",
  prompts: "M4 4h16v6H4zM4 14h10v6H4zM17 14h3M17 17h3M17 20h3",
  jobs: "M12 2v20M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
  budget: "M3 6h15v3M3 6v14h18V9H3M16 14.5h.01M3 6l12-3v3",
  chart: "M4 4v16h16M8 16v-4M12 16V8M16 16v-6",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  ocs: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21c0-4 3.5-6 8-6s8 2 8 6",
  gesture: "M13 4a1.5 1.5 0 1 0 0-.01M10 21l2-6-3-3 2-4 4 3h3M12 15l3 3v3M9 12l-4 1",
  japanese: "M3 7h12v14H3zM7 3h14v14M6 11h6M9 11v6M6 17h6",
  calendar: "M3 5h18v16H3zM3 10h18M8 2v5M16 2v5M7 14h2M11 14h2M15 14h2M7 17h2M11 17h2",
  map: "M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3zM9 3v15M15 6v15",
  locate: "M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM12 2v3M12 19v3M2 12h3M19 12h3",
  star: "M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z",
  route: "M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM8 17h7.5a3.5 3.5 0 0 0 0-7h-7a3.5 3.5 0 0 1 0-7H16",
  cat: "M5 3l4 4h6l4-4v9a7 7 0 0 1-14 0zM9 12h.01M15 12h.01M10 16c1 1 3 1 4 0",
  roulette: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 3v18M3.6 8.5l16.8 7M3.6 15.5l16.8-7M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  calc: "M5 2h14v20H5zM8 5h8v4H8zM8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01M16 17h.01",
  board: "M12 12h.01M8.5 8.5a5 5 0 0 0 0 7M15.5 8.5a5 5 0 0 1 0 7M5.6 5.6a9 9 0 0 0 0 12.8M18.4 5.6a9 9 0 0 1 0 12.8",
  doodle: "M3 20c3-1 4-4 7-4s2 3 5 3 4-2 6-3M14.5 4.5l5 5L10 19l-6 1 1-6z",
  clip: "M9 3h6v3H9zM7 4.5H5V21h14V4.5h-2M8.5 11h7M8.5 15h7",
  scan: "M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4M3 12h18",
  server: "M3 4h18v6H3zM3 14h18v6H3zM7 7h.01M7 17h.01M11 7h6M11 17h6",
  logs: "M4 4h16v16H4zM8 9l3 3-3 3M13 15h4",
  people: "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c0-3.5 2.8-5.5 6.5-5.5s6.5 2 6.5 5.5M16 4.5a3.5 3.5 0 0 1 0 6.5M18 14.8c2.2.6 3.5 2.4 3.5 5.2",
  share: "M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM8.6 13.5l6.8 4M15.4 6.5l-6.8 4",
  claude: "M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4",
  settings: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1",
  web: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18",
  grid: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z",
  plus: "M12 5v14M5 12h14",
  refresh: "M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7",
  back: "M15 5l-7 7 7 7",
  close: "M6 6l12 12M18 6 6 18",
  next: "M9 5l7 7-7 7",
  shuffle: "M3 7h4l10 10h4M17 21l4-4-4-4M3 17h4l3-3M14 10l3-3h4M17 3l4 4-4 4",
  trash: "M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14",
  open: "M14 4h6v6M20 4l-9 9M18 14v6H4V6h6",
  search: "M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zM16 16l5 5",
  send: "M4 12 20 4l-6 16-3-7z",
  check: "M4 12l5 5L20 6",
  play: "M7 4l13 8-13 8z",
  pause: "M7 4h4v16H7zM14 4h4v16h-4z",
  print: "M7 9V3h10v6M7 17H4V9h16v8h-3M7 14h10v7H7z",
  camera: "M3 7h4l2-3h6l2 3h4v13H3zM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  upload: "M12 16V4M7 9l5-5 5 5M4 20h16",
  download: "M12 4v12M7 11l5 5 5-5M4 20h16",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  spark: "M12 3l2 7 7 2-7 2-2 7-2-7-7-2 7-2z",
  pin: "M9 3h6l-1 6 4 4H6l4-4zM12 13v8",
  goal: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM12 12h.01",
  minus: "M5 12h14",
  edit: "M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4",
  undo: "M9 14 4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3",
  repeat: "M4 12a8 8 0 0 1 14-5.3M20 3v4h-4M20 12a8 8 0 0 1-14 5.3M4 21v-4h4",
  bell: "M6 16V11a6 6 0 1 1 12 0v5l2 2H4zM10 21h4",
  memory: "M6 4h12v16H6zM9 4V2M15 4V2M9 22v-2M15 22v-2M9 9h6M9 13h6",
  power: "M12 3v9M6.3 6.3a8 8 0 1 0 11.4 0",
  whiteboard: "M3 4h18v12H3zM12 16v4M8 21l4-1 4 1M6.5 12c2-3.5 3.5-1 5.5-3.5S15 7 17.5 10",
  "wb-pen": "M4 20l1.5-5L15.5 5l3.5 3.5-10 10zM13 7.5l3.5 3.5M4 20l3-1",
  "wb-pencil": "M16 3l5 5L9 20l-6 1 1-6zM13.5 5.5l5 5M4 15l5 5",
  "wb-brush": "M20 3c-4 2-8 6-9.5 9.5l2 2C16 13 20 7 20 3zM9 13.5c-2.5 0-4.5 1.6-4.5 4 0 1.2-.8 2-2 2.5 3.5 1.3 8 .3 8.5-4z",
  "wb-marker": "M15 3l6 6-8 8-6-6zM7 11l-2.5 7.5 1 1L13 17M3 21l2.5-2.5",
  "wb-highlight": "M14 3l7 7-7 7-7-7zM7 10v5h-2l-2 4h7l2-2M10 13l4 4",
  "wb-eraser": "M9 20h11M4.5 15.5l9.5-9.5a2 2 0 0 1 2.8 0l2.7 2.7a2 2 0 0 1 0 2.8L13 18H8zM9.5 10.5l5.5 5.5",
  hand: "M8 13V5.5a1.5 1.5 0 0 1 3 0V11M11 11V4a1.5 1.5 0 0 1 3 0v7M14 11V5.5a1.5 1.5 0 0 1 3 0V12M17 12V9a1.5 1.5 0 0 1 3 0v5a7 7 0 0 1-7 7h-1a7 7 0 0 1-5.6-2.8L3.5 15a1.5 1.5 0 0 1 2.4-1.8L8 16",
  picker: "M14 6l4 4M16.5 3.5l4 4-3 3-4-4zM14.5 9.5 6 18H3v-3l8.5-8.5",
  redo: "M15 14l5-5-5-5M20 9H9a5 5 0 0 0 0 10h4",
  layers: "M12 3l9 5-9 5-9-5zM3 12.5l9 5 9-5M3 16.5l9 5 9-5",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  fit: "M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5M9 9h6v6H9z",
  lock: "M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4",
  unlock: "M5 11h14v10H5zM8 11V7a4 4 0 0 1 7.5-2",
  "eye-off": "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM4 4l16 16",
  up: "M5 15l7-7 7 7",
  down: "M5 9l7 7 7-7",
  "wb-ink": "M12 3c3 4 5 7 5 10a5 5 0 0 1-10 0c0-3 2-6 5-10zM12 21v-8",
  "wb-water": "M12 3c4 5 6 8 6 11a6 6 0 0 1-12 0c0-3 2-6 6-11zM9 15a3 3 0 0 0 3 3",
  "wb-air": "M5 18h.01M9 15h.01M13 12h.01M17 9h.01M19 5h.01M12 18h.01M16 15h.01M8 11h.01M15 18h.01",
  "wb-spray": "M8 10h8v11H8zM10 10V6h4v4M17 4h.01M20 6h.01M20 3h.01M18 8h.01",
  "wb-charcoal": "M5 19l4-9 7-6 4 4-6 7zM5 19l-1 2 2-1",
  "wb-chalk": "M4 16l9-9 4 4-9 9H4zM13 7l2-2 4 4-2 2",
  "wb-crayon": "M7 21l-3 0 1-4 11-11 3 3-11 11zM16 5l3-1 1 3",
  "wb-stipple": "M6 7h.01M12 5h.01M18 8h.01M8 12h.01M14 11h.01M19 14h.01M5 17h.01M11 16h.01M16 19h.01",
  "wb-rainbow": "M3 18a9 9 0 0 1 18 0M7 18a5 5 0 0 1 10 0M5 18a7 7 0 0 1 14 0",
  "wb-glitter": "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 17l.8 2.2L22 20l-2.2.8L19 23l-.8-2.2L16 20l2.2-.8z",
  "wb-neon": "M13 3L5 14h6l-1 7 8-11h-6z",
  "wb-boil": "M3 12c2-4 3 4 5 0s3 4 5 0 3 4 5 0 2 2 3 0",
  "wb-wave": "M2 12c2.5-6 5.5-6 8 0s5.5 6 8 0M20 12h2",
  "wb-flame": "M12 3c1 4 5 6 5 11a5 5 0 0 1-10 0c0-2 1-3 2-4 0 2 1 3 2 3 0-4 0-6 1-10z",
  "wb-march": "M3 12h3M9 12h3M15 12h3M21 12h0M4 7h2M10 7h2M16 7h2M4 17h2M10 17h2M16 17h2",
  "wb-glitch": "M4 8h10M8 12h12M4 16h9M17 8h3M3 12h2M15 16h5",
  "wb-pulse": "M2 12h4l2-6 3 12 3-9 2 3h6",
  "wb-text": "M5 6V4h14v2M12 4v16M9 20h6",
  "wb-select": "M5 5h4M15 5h4M5 19h4M15 19h4M5 9v6M19 9v6M12 11l6 4-3 1 2 3-2 1-2-3-2 2z",
  "wb-shape": "M4 14h9v7H4zM16 9a5 5 0 1 0 0 .01zM12 3l-2 6h4z",
  "wb-stroke-erase": "M4 14l8-8 7 7-6 6H8zM8 6l4-3M16 18l4-4M10 20h10",
  "wb-onion": "M12 4c-3 3-6 6-6 10a6 6 0 0 0 12 0c0-4-3-7-6-10zM9 14a3 3 0 0 0 3 3",
  "wb-frame-add": "M4 5h16v14H4zM12 9v6M9 12h6",
  "wb-frame-copy": "M8 8h12v12H8zM4 4h12v2M4 4v12h2",
  "wb-prev": "M15 5l-7 7 7 7",
  "wb-next": "M9 5l7 7-7 7",
  "wb-turn-left": "M4 12a8 8 0 1 0 3-6.2M4 3v5h5",
  "wb-turn-right": "M20 12a8 8 0 1 1-3-6.2M20 3v5h-5",
  "wb-turn": "M20 12a8 8 0 1 1-3-6.2M20 3v5h-5M12 12h.01",
  "wb-flip": "M12 3v18M8 7 3 17h5zM16 7l5 10h-5z",
  "wb-flip-v": "M3 12h18M7 8l10-5v5zM7 16l10 5v-5z",
  "wb-compass": "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 6l2.5 6-2.5 6-2.5-6z",
  "wb-keys": "M3 6h18v12H3zM7 10h.01M11 10h.01M15 10h.01M7 14h10",
  "wb-smudge": "M4 19c3 0 5-1 6-3l7-9-3-3-9 7c-2 1-3 3-3 6zM14 4l6 6M5 19l3 2",
  "wb-blend": "M9 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM15 9a5 5 0 1 0 0 10 5 5 0 0 0 0-10z",
  "wb-blur": "M12 3c4 5 6 8 6 11a6 6 0 0 1-12 0c0-3 2-6 6-11zM8 14h.01M12 17h.01M12 13h.01M16 14h.01",
  "wb-lighten": "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2",
  "wb-darken": "M20 14A8 8 0 1 1 10 4a7 7 0 0 0 10 10z",
  "wb-lasso": "M12 4c5 0 9 2 9 5s-4 5-9 5-9-2-9-5 4-5 9-5zM8 13.500c-1.500 1-2 2.200-2 3.500 0 1.500 1 3 3 3 1.500 0 2.500-1 2.500-2",
  "wb-fill": "M5 11l7-7 7 7-7 7zM5 11h14M20 15c1 1.500 2 2.500 2 3.500a2 2 0 0 1-4 0c0-1 1-2 2-3.500z",
  car: "M4 16l1.500-5h13L20 16M4 16v3h3v-2h10v2h3v-3M4 16h16M7.500 13.500h.01M16.500 13.500h.01",
  music: "M9 18V5l11-2v13M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM20 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
  tracker: "M4 4h16v16H4zM4 9h16M4 14h16M10 4v16M14 11.500h3M6.500 6.500h.01M14 16.500h3",
  tierlist: "M3 4h5v4H3zM11 6h10M3 10h5v4H3zM11 12h10M3 16h5v4H3zM11 18h10",
  sort: "M7 4v16M7 20l-3-3M7 20l3-3M17 20V4M17 4l-3 3M17 4l3 3",
  filter: "M4 6h16M7 12h10M10 18h4"
};

export function iconPath(name: string): string {
  return PATHS[name] || PATHS.grid;
}

export function iconSvg(name: string, size = 24): string {
  const path = PATHS[name] || PATHS.grid;
  return `<svg class="icon" viewBox="0 0 24 24" width="${size}" height="${size}" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter"><path d="${path}"/></svg>`;
}

export function icon(name: string, size = 24): HTMLElement {
  const holder = document.createElement("span");
  holder.className = "icon-wrap";
  holder.innerHTML = iconSvg(name, size);
  return holder;
}

// swaps every <i data-icon="name"> in the markup for its svg
export function stampIcons(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>("i[data-icon]").forEach((slot) => {
    if (slot.firstElementChild) return;
    slot.innerHTML = iconSvg(slot.dataset.icon || "grid", Number(slot.dataset.size) || 20);
  });
}
